import actionsFactory from 'magic/actionsFactory';

const createAction = actionsFactory('personDoubles/');

export const clearWsPersonDoubleFromCollection = createAction('clearWsPersonDoubleFromCollection');
export const setWsPersonActiveDouble = createAction('setWsPersonActiveDouble');
export const setUserById = createAction('setUserById');
export const purgeUserById = createAction('purgeUserById');
export const setWsPersonDoublesCollection = createAction('setWsPersonDoublesCollection');
export const removeWsPersonDoubleFromCollection = createAction('removeWsPersonDoubleFromCollection');
